import { FormContainer } from 'components';
import { useTranslation } from 'libs/i18n';

import {
  KnowledgeAndExperienceFormType,
  FormErrors,
  getSchema,
} from '../../forms/knowledgeAndExperienceForm';

import { FormContent } from './FormContent';

interface Props {
  initialValues?: KnowledgeAndExperienceFormType;
  onSubmit: (values: KnowledgeAndExperienceFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
}

export const KnowledgeAndExperience = ({
  initialValues,
  canGoBack,
  submitLoading,
  formError,
  onGoBack,
  onSubmit,
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema();
  return (
    <FormContainer
      canGoBack={canGoBack}
      initialErrors={formError}
      initialValues={initialValues}
      submitLoading={submitLoading}
      subTitle={t('onboarding.legalKnowledgeAndExperience.subtitle')}
      title={t('onboarding.legalKnowledgeAndExperience.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent />
    </FormContainer>
  );
};
